module.exports = "<div class=\"ot-stepper\">\n  <span ng-repeat-start=\"item in params.items\" ng-class=\"{'ot-current': params.current == $index}\">\n      {{item | translate}}\n  </span>\n\n  <span ng-show=\"!$last\" ng-repeat-end>&nbsp;&#062;&nbsp;</span>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/common/stepper.html
 ** module id = 257
 ** module chunks = 1
 **/